export const vuplexResolution = {
	width: 469,
	height: 650,
};
